import { Component } from '@angular/core';
import { FIREBASE_CONFIG } from 'src/environments/environment';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics'
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor() {


    firebase.initializeApp(FIREBASE_CONFIG);

  }
}
